<template>
  <AppTypeAhead
    v-model="inputValue"
    class="form-input"
    :name="$props.name"
    :suggestion-callback="getSuggestions"
    :initial-suggestions="getSuggestions"
    :error="$props.error"
    @value-selected="inputValue = filteredUnits[$event]"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    name: string;
    error?: string;
  }>(),
  {
    error: undefined,
  },
);

const inputValue = defineModel<string>();

const units = [
  'm',
  'm2',
  'm3',
  'T',
  'days',
  'weeks',
  'months',
  'sum',
  'item',
  'No.',
];

const filteredUnits = computed(() => {
  return units.filter((unit) => {
    return unit.includes(inputValue.value);
  });
});

const getSuggestions = () => {
  return filteredUnits.value;
};
</script>

<style scoped></style>
